class ExtensionsCategoryFilter extends HTMLElement {
  constructor() {
    super();

    this.grid = document.querySelector(".main-extensions-hub__grid");
    this.cards = this.grid
      ? Array.from(this.grid.querySelectorAll(".extension-hub-card"))
      : [];
    this.countEl = document.getElementById("ExtensionCount");
    this.searchInputs = Array.from(
      document.querySelectorAll(".main-extensions-hub [data-extension-search-input]")
    );
    this.activeCategory = "";
    this.searchQuery = "";

    this.onFilterClick = this.onFilterClick.bind(this);
    this.onSearchInput = this.onSearchInput.bind(this);
    this.applyFromUrl = this.applyFromUrl.bind(this);

    this.querySelectorAll(".main-blog__tag-filter-link").forEach((link) => {
      link.addEventListener("click", this.onFilterClick);
    });

    this.searchInputs.forEach((input) => {
      input.addEventListener("input", this.onSearchInput);
    });

    this.applyFromUrl();
    window.addEventListener("popstate", this.applyFromUrl);
  }

  onFilterClick(event) {
    event.preventDefault();
    const link = event.currentTarget;
    if (!link.classList.contains("main-blog__tag-filter-link")) return;

    const category = link.dataset.category || "";
    this.setActiveLink(link);
    this.activeCategory = category;
    this.applyFilters();
    this.updateUrl(category);
  }

  onSearchInput(event) {
    this.searchQuery = event.target.value.trim().toLowerCase();
    this.searchInputs.forEach((input) => {
      if (input !== event.target) {
        input.value = event.target.value;
      }
    });
    this.applyFilters();
  }

  applyFromUrl() {
    const category =
      new URLSearchParams(window.location.search).get("category") || "";
    const link = category
      ? this.querySelector(
          `.main-blog__tag-filter-link[data-category="${category}"]`
        )
      : this.querySelector(".main-blog__tag-filter-link.clear-filters");

    if (link) {
      this.setActiveLink(link);
      this.activeCategory = category;
      this.applyFilters();
    }
  }

  setActiveLink(activeLink) {
    this.querySelectorAll(".main-blog__tag-filter-link").forEach((link) => {
      link.classList.toggle("active", link === activeLink);
    });
  }

  applyFilters() {
    let visibleCount = 0;

    this.cards.forEach((card) => {
      const categoryMatch =
        !this.activeCategory ||
        card.dataset.extensionCategory === this.activeCategory;
      const searchBlob = card.dataset.extensionSearch || "";
      const searchMatch =
        !this.searchQuery || searchBlob.includes(this.searchQuery);
      const show = categoryMatch && searchMatch;

      card.hidden = !show;
      if (show) visibleCount += 1;
    });

    this.updateCount(visibleCount);
  }

  updateCount(count) {
    if (!this.countEl) return;

    const total = count ?? this.cards.filter((card) => !card.hidden).length;
    const label = total === 1 ? "guide" : "guides";
    this.countEl.textContent = `${total} ${label}`;
  }

  updateUrl(category) {
    const url = new URL(window.location.href);

    if (category) {
      url.searchParams.set("category", category);
    } else {
      url.searchParams.delete("category");
    }

    const next = `${url.pathname}${url.search}${url.hash}`;
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;

    if (next !== current) {
      window.history.pushState({}, "", next);
    }
  }
}

if (!customElements.get("extensions-category-filter")) {
  customElements.define("extensions-category-filter", ExtensionsCategoryFilter);
}

function initStandaloneExtensionsSearch() {
  if (document.querySelector("extensions-category-filter")) return;

  const inputs = Array.from(
    document.querySelectorAll(".main-extensions-hub [data-extension-search-input]")
  );
  const grid = document.querySelector(".main-extensions-hub__grid");
  const countEl = document.getElementById("ExtensionCount");

  if (!inputs.length || !grid) return;

  const cards = Array.from(grid.querySelectorAll(".extension-hub-card"));

  const applySearch = (sourceInput) => {
    const query = sourceInput.value.trim().toLowerCase();
    inputs.forEach((input) => {
      if (input !== sourceInput) {
        input.value = sourceInput.value;
      }
    });

    let visibleCount = 0;

    cards.forEach((card) => {
      const searchBlob = card.dataset.extensionSearch || "";
      const show = !query || searchBlob.includes(query);
      card.hidden = !show;
      if (show) visibleCount += 1;
    });

    if (countEl) {
      const label = visibleCount === 1 ? "guide" : "guides";
      countEl.textContent = `${visibleCount} ${label}`;
    }
  };

  inputs.forEach((input) => {
    input.addEventListener("input", () => applySearch(input));
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initStandaloneExtensionsSearch);
} else {
  initStandaloneExtensionsSearch();
}
